export default __webpack_public_path__ + "static/media/OI.177dc1bb.webp";